import {
  Button,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Empty,
  Flex,
  Form,
  Input,
  message,
  Row,
  Select,
  Tooltip,
  Typography,
  notification,
  Popover,
  Checkbox
} from 'antd';
import axios from 'axios';
import { apiBasePath, apiBasePathSigie, CALENDAR_DAYS_AVAILABLE } from '../../utils/constants';
import { useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/es_ES';
import { allowOnlyNumbers, currencyFormatter, sum, withTrimmedForm } from '../../utils/utils';
import { Loading } from '../common';
import { ContainerOutlined, DeleteOutlined, InfoCircleOutlined, MailOutlined, PlusOutlined } from '@ant-design/icons';
import './InvoiceTickets.css';
import { GlobalContext } from '../../utils/globalContext';
import { useNavigate } from 'react-router-dom';
import { RemoteSearchClients } from '../common/SearchClients';

export const InvoiceTickets = () => {
  const [form] = Form.useForm();
  const [parkingList, setParkingList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [cfdiUse, setCFDIuse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [remoteConfig, setRemoteConfig] = useState({
    maxDocument: 1,
    availablePaymentInfo: false,
    availablePension: false
  });
  const [emails, setEmails] = useState([]);
  const [amountsAdded, setAmountsAdded] = useState([]);
  const [validateTicket, setValidateTicket] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [notificationApi, contextHolderNotification] = notification.useNotification();
  const { user } = useContext(GlobalContext);
  const navigate = useNavigate();
  const onFinish = async (values) => {
    if (remoteConfig.maxDocument <= amountsAdded.length) {
      messageApi.open({
        type: 'warning',
        content: 'Ya se ha agregado el maximo de boletos por factura'
      });
      return;
    }
    setLoadingSave(true);
    try {
      const fecha = dayjs(values.date).format('YYYY-MM-DD');

      if (validateTicket) {
        const responseCodeValidate = await axios.get(
          `${apiBasePath}/invoice/codbar-by-codbar-and-parking/codbar/${values.ticketcode}/cfiscal_cates_id_int/${values.parking}`
        );
        const codeAlreadyAdded = responseCodeValidate.data.lstComprobanteFiscal;
        if (codeAlreadyAdded.length > 0) {
          messageApi.open({
            type: 'warning',
            content: 'El código de boleto ya fue agregado'
          });
          return;
        }
      }

      const responseInsertInvoice = await axios.get(
        `${apiBasePathSigie}/external-data/income/ticket/operation-date/${fecha}/parking-code/${values.parking}`
      );
      const amountMapping = responseInsertInvoice.data?.lstInvoiceTicketExternal || [];
      const findingAmount = amountMapping.find((item) => String(item.amount) === values.amount);

      if (!amountsAdded.some((ticket) => ticket.ticketcode === values.ticketcode)) {
        if (!findingAmount) {
          messageApi.open({
            type: 'warning',
            content: 'No se encontro boleto con ese monto'
          });
          return;
        }
        setAmountsAdded([...amountsAdded, { ...findingAmount, ticketcode: values.ticketcode, amount: values.amount }]);
      } else {
        messageApi.open({
          type: 'warning',
          content: 'El código de boleto ya fue agregado'
        });
      }
    } catch (error) {
      console.error('🚀 ~ onFinish ~ error:', error);
    } finally {
      setLoadingSave(false);
    }
  };
  const handleInvoice = async () => {
    setLoadingInvoice(true);
    const inputsValues = form.getFieldsValue();
    try {
      await axios.post(`${apiBasePath}/invoice`, {
        cates_descr_corta_str: parkingList.find(
          (parking) => String(parking.cates_id_int) === String(inputsValues.parking)
        ).cates_descr_corta_str,
        cates_id_int: inputsValues.parking,
        clie_id: user.isAdmin ? inputsValues.clientInvoice : user.clie_id,
        invoiceCaptureDetail: amountsAdded?.map((item) => ({ amount: item.amount, code: item.ticketcode })),
        invoiceEmail: emails?.map((email) => ({ email })),
        invoice_type: user.isAdmin ? inputsValues.invoiceType : 1,
        invoice_way_payment: inputsValues.wayPayment,
        forma_pago: inputsValues.paymentType,
        metodo_pago: inputsValues.paymentMethod,
        valida_folio: validateTicket ? 1 : 0,
        oper_fecha: dayjs(inputsValues.date).format('YYYY-MM-DD'),
        oper_uso_cfdi: cfdiUse.find((cfdi) => cfdi.id === inputsValues.cfdi).code,
        oper_uso_cfdi_desc: cfdiUse.find((cfdi) => cfdi.id === inputsValues.cfdi).description,
        oper_sistema: user.isAdmin ? 2 : 1
      });
      notificationApi.open({
        type: 'info',
        message: 'Facturación en proceso',
        description: 'Su documento se encuentra en proceso de facturación, favor de validar en el Menú de Mis Facturas',
        btn: (
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(user.isAdmin ? '/invoice-monitor' : '/invoice-list')}>
            {user.isAdmin ? 'Ir a Monitor de Facturas' : 'Ir a Mis Facturas'}
          </Button>
        ),
        showProgress: true,
        duration: 0,
        pauseOnHover: true
      });
      form.resetFields();
      setAmountsAdded([]);
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: 'Error al intentar generar la facturar, por favor contacte al administrador'
      });
    } finally {
      setLoadingInvoice(false);
    }
  };
  const getInitData = async () => {
    setLoading(true);
    try {
      const responsePaymentMethodList = await axios.get(`${apiBasePath}/reference-data/way-payment`);
      setPaymentMethodList(responsePaymentMethodList.data.wayPayment.data);
      const responseParkingList = await axios.get(`${apiBasePath}/reference-data/parking`);
      const responseCFDIList = await axios.get(`${apiBasePath}/reference-data/cfdi-use`);
      const respConfigMaxInvoice = await axios.get(
        `${apiBasePath}/reference-data/conf-general/MAX_QUANTITY_INVOICE_DOCUMENT`
      );
      const respConfigAvailablePaymentInfo = await axios.get(
        `${apiBasePath}/reference-data/conf-general/AVAILABLE_PAYMENT_INFO`
      );
      const respConfigAvailablePension = await axios.get(
        `${apiBasePath}/reference-data/conf-general/AVAILABLE_PENSION`
      );
      setRemoteConfig({
        ...remoteConfig,
        maxDocument: respConfigMaxInvoice.data.generalConfig.conf_value,
        availablePaymentInfo: respConfigAvailablePaymentInfo.data.generalConfig.conf_value === '1',
        availablePension: respConfigAvailablePension.data.generalConfig.conf_value === '1'
      });
      setCFDIuse(responseCFDIList.data?.cfdiUse?.data);
      setParkingList(responseParkingList.data.lstParking);
      setEmails([user.clie_correo]);
    } catch (error) {
      console.error('🚀 ~ getParkingList ~ error:', error);
    } finally {
      setLoading(false);
    }
  };
  const disabledDate = (current) => {
    if (user.isAdmin) return false;
    return (
      current && (current.isAfter(dayjs().endOf('day')) || current.isBefore(dayjs().subtract(CALENDAR_DAYS_AVAILABLE, 'days').startOf('day')))
    );
  };
  const handleEmails = (e) => {
    const { value } = e.target;
    if (value.includes(',')) {
      const emails = value.split(',');
      setEmails(emails);
    } else {
      setEmails([value]);
    }
  };
  const handleDelete = (index) => {
    const updatedAmounts = amountsAdded.filter((_, i) => i !== index);
    setAmountsAdded(updatedAmounts);
  };
  const handleClientSelect = (client) => {
    if (!client) {
      form.setFieldsValue({ clientInvoice: null });
      return;
    }
    form.setFieldsValue({ clientInvoice: client.clie_id });
  };
  const onValidateTicketChange = (e) => {
    setValidateTicket(e.target.checked);
  };
  useEffect(() => {
    getInitData();
  }, []);
  return (
    <div className="basic-layout">
      {contextHolder}
      {contextHolderNotification}
      <Flex justify="space-between" align="center" className="basic-layout-header">
        <h1>{user.isAdmin ? 'Facturación' : 'Facturación de Boletaje'}</h1>
      </Flex>
      <Divider />
      <Row gutter={32} justify="center">
        <Col md={12} xs={24} sm={24}>
          <h3> Datos para facturar</h3>
          <Divider />
          <Form
            name="invoiceTickets"
            form={form}
            autoComplete="off"
            layout="vertical"
            onFinish={withTrimmedForm(onFinish)}>
            <Row gutter={16}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="parking"
                  label="Estacionamiento"
                  rules={[{ required: true, message: 'Por favor, ingresa el estacionamiento' }]}>
                  <Select
                    loading={loading}
                    allowClear
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                    {parkingList?.map((parking) => (
                      <Select.Option
                        key={parking.cates_id_int}
                        value={parking.cates_id_int}
                        label={`${parking.cates_id_int} - ${parking.cates_descripcion_str}`}>
                        {`${parking.cates_id_int} - ${parking.cates_descripcion_str}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="date"
                  label="Fecha"
                  rules={[{ required: true, message: 'Por favor, ingresa la fecha' }]}>
                  <DatePicker
                    locale={locale}
                    format={'DD-MM-YYYY'}
                    disabledDate={disabledDate}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              {user.isAdmin && (
                <>
                  <Col md={12} xs={24}>
                    <Form.Item
                      name="clientInvoice"
                      label="Cliente"
                      rules={[{ required: true, message: 'Por favor, ingresa el cliente' }]}>
                      <RemoteSearchClients onSelectClient={handleClientSelect} />
                    </Form.Item>
                  </Col>
                </>
              )}
              <Col md={user.isAdmin ? 12 : 24} xs={24}>
                <Form.Item
                  name="cfdi"
                  label="Uso de CFDI"
                  rules={[{ required: true, message: 'Por favor, ingresa el uso de CFDI' }]}>
                  <Select
                    loading={loading}
                    allowClear
                    showSearch
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}>
                    {cfdiUse?.map((cfdi) => (
                      <Select.Option key={cfdi.id} value={cfdi.id} label={`${cfdi.code} - ${cfdi.description}`}>
                        {`${cfdi.code} - ${cfdi.description}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="paymentMethod"
                  label="Método de Pago"
                  initialValue={'PUE'}
                  rules={[{ required: true, message: 'Por favor, ingresa el método de pago' }]}>
                  <Select
                    defaultValue={'PUE'}
                    disabled={!user.isAdmin && !remoteConfig.availablePaymentInfo}
                    options={[
                      { value: '', label: 'Seleccione método de pago' },
                      { value: 'PPD', label: 'PPD - Pago en parcialidades o diferido' },
                      { value: 'PUE', label: 'PUE - Pago en una exhibición' }
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="paymentType"
                  label="Forma de Pago"
                  initialValue={'01'}
                  rules={[{ required: true, message: 'Por favor, ingresa la forma de pago' }]}>
                  <Select
                    defaultValue={'01'}
                    showSearch
                    disabled={!user.isAdmin && !remoteConfig.availablePaymentInfo}
                    filterOption={(input, option) => option?.label.toLowerCase().includes(input.toLowerCase())}
                    options={[
                      { value: '', label: 'Seleccione forma de pago' },
                      ...paymentMethodList.map((paymentMethod) => ({
                        value: paymentMethod.code,
                        label: `${paymentMethod.code} - ${paymentMethod.description}`
                      }))
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              {user.isAdmin && (<Col md={8} xs={24}>
                <Form.Item
                  name="invoiceType"
                  label="Tipo de Factura"
                  initialValue={1}
                  rules={[{ required: true, message: 'Por favor, ingresa el tipo de factura' }]}>
                  <Select
                    defaultValue={1}
                    disabled={!user.isAdmin && !remoteConfig.availablePension}
                    options={[
                      { value: 1, label: 'Boletaje' },
                      { value: 2, label: 'Pensiones' }
                    ]}
                  />
                </Form.Item>
              </Col>)}
              <Col md={user.isAdmin ? 8 : 12} xs={24}>
                <Form.Item
                  name="ticketcode"
                  style={{ marginBottom: 0 }}
                  label={
                    <Popover
                      content={() => (
                        <Row align="center" justify="space-between" gutter={16}>
                          <Col span={12}>
                            <h5>Vertical</h5>
                            <img src={`${process.env.PUBLIC_URL}/boletoVertical.png`} alt="info" width={220} />
                          </Col>
                          <Col span={12}>
                            <h5>Horizontal</h5>
                            <img src={`${process.env.PUBLIC_URL}/boletoHorizontal.png`} alt="info" width={220} />
                          </Col>
                        </Row>
                      )}
                      title="Identifica tu tipo de boleto">
                      <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                        Folio {<InfoCircleOutlined />}
                      </span>
                    </Popover>
                  }
                  rules={[
                    { required: true, message: 'Por favor, ingresa el Código del boleto' },
                    { max: 15, message: 'El Código no puede superar los 15 caracteres' }
                  ]}>
                  <Input />
                </Form.Item>
                {user.isAdmin && (
                  <Form.Item name="validateTicket" style={{ marginBottom: 0 }}>
                    <Checkbox checked={validateTicket} defaultValue={true} onChange={onValidateTicketChange}>
                      validar folio
                    </Checkbox>
                  </Form.Item>
                )}
              </Col>
              <Col md={user.isAdmin ? 8 : 12} xs={24}>
                <Form.Item
                  name="amount"
                  label="Importe"
                  rules={[{ required: true, message: 'Por favor, ingresa el Importe' }]}>
                  <Input addonBefore="$" onKeyDown={(e) => allowOnlyNumbers(e, true)} />
                </Form.Item>
              </Col>
            </Row>
            <Flex justify="end">
              <Button type="primary" icon={<PlusOutlined />} htmlType="submit" size="large" loading={loadingSave}>
                Agregar
              </Button>
            </Flex>
          </Form>
        </Col>
        <Col md={12} xs={24} sm={24}>
          {loadingSave ? (
            <Loading />
          ) : (
            <>
              {amountsAdded.length > 0 ? (
                <>
                  <Flex justify="space-between" align="center">
                    <h3>Boletos a facturar</h3>
                    <Input
                      style={{ width: 300 }}
                      onBlur={handleEmails}
                      onKeyUp={(e) => {
                        e.target.value = e.target.value.replace(/\s+/g, '');
                      }}
                      defaultValue={user.clie_correo}
                      placeholder="Ingresa los correos separados por comas"
                      prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                      suffix={
                        <Tooltip title="Ingresa los correos separados por comas sin espacios o saltos de linea.">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                    <Button
                      type="primary"
                      loading={loadingInvoice}
                      disabled={loadingInvoice}
                      size="large"
                      icon={<ContainerOutlined />}
                      onClick={handleInvoice}>
                      Facturar
                    </Button>
                  </Flex>
                  <Divider style={{ marginTop: 8 }} />
                  <Flex justify="center" align="start" style={{ width: '100%' }}>
                    <Descriptions
                      bordered
                      column={1}
                      size="small"
                      id="tickets-to-invoice-description"
                      style={{ width: 400 }}>
                      <Descriptions.Item label="Código de boleto" style={{ paddingRight: 56, fontWeight: 700 }}>
                        Importe
                      </Descriptions.Item>
                      {amountsAdded?.map((amount, index) => (
                        <Descriptions.Item label={amount?.ticketcode} key={`amounts-added-${index}`}>
                          {currencyFormatter(amount?.amount)}
                          <Button
                            type="link"
                            icon={<DeleteOutlined />}
                            onClick={() => handleDelete(index)}
                            style={{ marginLeft: 8 }}
                          />
                        </Descriptions.Item>
                      ))}
                      <Descriptions.Item label="Total" span={2} style={{ paddingRight: 56, fontWeight: 700 }}>
                        {currencyFormatter(amountsAdded?.reduce((total, amount) => sum(total, amount.amount), 0))}
                      </Descriptions.Item>
                    </Descriptions>
                  </Flex>
                </>
              ) : (
                <Flex justify="center" align="center" style={{ height: '100%' }}>
                  <Empty description={<Typography.Text>Agrega tus códigos para facturar</Typography.Text>} />
                </Flex>
              )}
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};
